export type ClassValue = string | false | null | undefined | ClassValue[];

const collectValues = (value: ClassValue, target: string[]) => {
  if (!value) {
    return;
  }

  if (Array.isArray(value)) {
    value.forEach(item => collectValues(item, target));
    return;
  }

  const tokens = value
    .split(/\s+/)
    .map(token => token.trim())
    .filter(Boolean);

  target.push(...tokens);
};

export const cn = (...values: ClassValue[]): string => {
  const tokens: string[] = [];
  values.forEach(value => collectValues(value, tokens));

  if (tokens.length === 0) {
    return '';
  }

  const seen = new Set<string>();
  const uniqueTokens: string[] = [];

  tokens.forEach(token => {
    if (!seen.has(token)) {
      seen.add(token);
      uniqueTokens.push(token);
    }
  });

  return uniqueTokens.join(' ');
};

export default cn;
